// eslint-disable-next-line import/prefer-default-export
export function setPatientDetails(actionContext, payload) {
	actionContext.dispatch('SET_PATIENT_DETAILS_FINISH', payload);
}
